import React, { useEffect } from 'react';
import { MapContainer, TileLayer, Marker, Popup } from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix for default marker icon issue
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
    iconRetinaUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon-2x.png',
    iconUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-icon.png',
    shadowUrl: 'https://unpkg.com/leaflet@1.7.1/dist/images/marker-shadow.png',
});

const SinglePropertiesMap = ({ coordinates }) => {
    useEffect(() => {
        if (!coordinates || !coordinates.lat || !coordinates.lng) {
            console.error('Invalid coordinates provided');
        }
    }, [coordinates]);

    if (!coordinates || !coordinates.lat || !coordinates.lng) {
        return <div>Invalid coordinates</div>;
    }

    return (
        <MapContainer center={[coordinates.lat, coordinates.lng]} zoom={12} style={{ height: '100%', width: '100%', borderRadius:'12px' }}>
            <TileLayer
                url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
                attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
            />
            <Marker position={[coordinates.lat, coordinates.lng]}>
            </Marker>
        </MapContainer>
    );
};

export default SinglePropertiesMap;